/*
 *  Popup Newsletter
 *    Scripts for the Newsletter Popup
 *
 *  Version 1.0.0 - 2020/09/28
 *
 */
import { ShopifySection, register } from './../../sections/ShopifySection';
import $ from 'jquery';
import * as ResponsiveSizes from './../../settings/Responsive';
import Cookies from 'js-cookie';

export const CLASS_OPEN = 'is-open';
export const CLASS_POPUP_OPEN = 'is-popup-open';
export const CONTENT_CONTAINER = '[data-newsletter-popup]';
export const POPUP_INNER = '[data-newsletter-popup-inner]';
export const CLOSE_BUTTON = '[data-close-popup]';
export const POPUP_EXPIRE = 'data-popup-expiry';
export const POPUP_DELAY = 'data-popup-delay';
export const POPUP_COOKIE = 'hide-popup';

export class PopupNewsletter extends ShopifySection {
  constructor(container) {
    super(container);
    this.popup = container.find(POPUP_INNER);
    this.close = container.find(CLOSE_BUTTON);
    this.expiry = parseInt(container.attr(POPUP_EXPIRE));
    this.delay = parseInt(container.attr(POPUP_DELAY));
    this.body = $('body');
    this.checkCookie();
    // Events
    $(document).on('click touch', (e) => this.closePopup(e));
  }
  onPopupToggle() {
    if (this.container.hasClass(CLASS_OPEN)) {
      this.container.removeClass(CLASS_OPEN);
      this.body.removeClass(CLASS_POPUP_OPEN);
      this.body.css('height', '');
    } else {
      if(Cookies.get(POPUP_COOKIE)) return;
      this.container.addClass(CLASS_OPEN);
      this.body.addClass(CLASS_POPUP_OPEN);
      // setting cookie
      this.setCookie();
      // Set the height of the screen to prevent background scrolling
      let width = $(window).width();
      let vpH = $(window).innerHeight();
      setTimeout(() => { this.body.css('height', `${vpH.toString()}px`); }, 500);
      if(width > ResponsiveSizes.small-1) return;
    }
  }
  setCookie() {
    Cookies.set(POPUP_COOKIE, true, { expires: this.expiry });
  }
  checkCookie() {
    if(Cookies.get(POPUP_COOKIE)) return;
    // add 1 to the delay in-case the delay setting is set to zero
    let popupDelay = (this.delay + 1) * 1000;
    if (this.container.length) {
      setTimeout(() => {
        this.onPopupToggle();
      }, popupDelay)
    }
  }
  closePopup(e) {
    let target = e.target;
    // don't close if popup clicked except for close button
    if ($(target).is(this.popup) || 
        this.popup.find(target).length >= 1 && 
        !($(target).is(this.close) || 
          this.close.find(target).length >= 1)) {
      return;
    };
    this.onPopupToggle();
  }
}
register(CONTENT_CONTAINER, PopupNewsletter);